module.exports = __webpack_public_path__ + "static/media/tour-produto-2.2e11b7df.png";